import React from 'react';
import moment from 'moment';

export default class CommentRow extends React.Component {
  render() {
    const {RowData} = this.props

    return (
      <div className="comment" key={RowData.Alias}>
        <strong className="spaceRR" >{RowData.Owner.FirstName}&nbsp;{RowData.Owner.LastName}</strong>
        <span className="time-string">{moment(RowData.CreatedTime).fromNow()}</span>
        <div className="comment-body break-word">
          {RowData.Content}
        </div>
        {/*Hidden comment row*/}
        {/*
          <div className="comment-toolbar">
          <button className="btn btn-link">Reply</button>
        </div>
        */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/Row/CommentRow.js